import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackBar(message: string): void {
    this.snackBar.open(message, null, {
      panelClass: 'snackbar-error',
      duration: 2000,
    });
  }

}
